import {
  Button,
  Card,
  CardBody,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Icon,
  Input,
  Stack,
  Text,
  useBoolean,
} from "@chakra-ui/react"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { FiFile } from "react-icons/fi"

import GeneratorsApi from "@shared/api/generators"
import { downloadFile } from "@shared/lib/utils"
import { errorsStr } from "@shared/resourses/strings"
import { MakeThumbnailData } from "@shared/types/api/formatters"
import FileUpload from "@shared/ui/file-upload"

const ImageThumbnail = () => {
  const [preview, setPreview] = useState<string>("")
  const [errorInfo, setErrorInfo] = useState<string>("")
  const [loading, setLoading] = useBoolean()

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<MakeThumbnailData>()

  const watchFiles = watch("file")

  const onSubmit = handleSubmit((data) => {
    setPreview("")
    setErrorInfo("")

    if (!loading) {
      setLoading.on()
      GeneratorsApi.makeThumbnail(data).then(({ result }) => {
        if (result) {
          setPreview(result.data.img)
        } else {
          setErrorInfo(errorsStr.SOMETHING_WENT_WRONG)
        }
        setTimeout(setLoading.off, 250)
      })
    }
  })

  const validateFiles = (value: FileList) => {
    if (value.length != 1) {
      return "Files is required"
    }
    for (const file of Array.from(value)) {
      const fsMb = file.size / (1024 * 1024)
      const MAX_FILE_SIZE = 10
      if (fsMb > MAX_FILE_SIZE) {
        return "Max file size 10mb"
      }
    }
    return true
  }

  return (
    <Stack>
      <form>
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
          <GridItem>
            <FormControl isInvalid={!!errors.file} isRequired>
              <FormLabel>File</FormLabel>
              <FileUpload accept={"image/*"} register={register("file", { validate: validateFiles })}>
                <Button w={"full"} leftIcon={<Icon as={FiFile} />}>
                  Upload File
                </Button>
              </FileUpload>
              <FormErrorMessage>{errors.file && errors?.file.message}</FormErrorMessage>
              {watchFiles && Array.from(watchFiles).map((file) => <Text key={file.name}>{file.name}</Text>)}
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isInvalid={!!errors.height} isRequired>
              <FormLabel>Height</FormLabel>
              <Input
                id={"height"}
                placeholder={"must be > 0"}
                type={"number"}
                {...register("height", { min: 1, required: true, valueAsNumber: true })}
              />
              <FormErrorMessage>{errors.height && errors?.height.message}</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={!!errors.width}>
              <FormLabel>Width</FormLabel>
              <Input
                id={"width"}
                placeholder={"must be > 0"}
                type={"number"}
                {...register("width", { min: 1, valueAsNumber: true })}
              />
              <FormErrorMessage>{errors.width && errors?.width.message}</FormErrorMessage>
            </FormControl>
          </GridItem>
          <GridItem colSpan={2}>
            <Button w={"full"} onClick={onSubmit} disabled={loading}>
              Make Thumbnail
            </Button>
          </GridItem>

          {errorInfo && (
            <GridItem colSpan={2}>
              <Center>
                <Text fontWeight={"bold"}>{errorInfo}</Text>
              </Center>
            </GridItem>
          )}

          {preview && (
            <GridItem colSpan={2}>
              <Button onClick={() => downloadFile(preview, "thumbnail.jpeg")}>Download</Button>
            </GridItem>
          )}

          <GridItem colSpan={2}>
            {preview && (
              <Center>
                <Card>
                  <CardBody>
                    <img src={preview} alt={"thumbnail result"} />
                  </CardBody>
                </Card>
              </Center>
            )}
          </GridItem>
        </Grid>
      </form>
    </Stack>
  )
}

export default ImageThumbnail
